<template>
  <div>
    <div class="mb-6">
      <h1 class="h4 primary--text">
        {{ $t('views.label_template.label_template') }}
      </h1>
    </div>

    <main>
      <b-row>
        <b-col cols="6">
          <label-template
            v-if="labelTemplates.length"
            :template-list="labelTemplates"
          />
        </b-col>
        <b-col cols="6">
          <div
            v-if="elements.length"
            class="label-template"
          >
            <h2 class="label-template__fields h5 mb-3">
              {{ $t('views.label_template.template_elements') }}
            </h2>
            <v-chip-group
              column
              class="mb-6"
            >
              <v-chip
                v-for="element of elements"
                :key="element"
                @click="copyToClipboard(element)"
              >
                {{ element }}
              </v-chip>
            </v-chip-group>

            <div v-if="fields.length">
              <h2 class="label-template__fields h5 mb-3">
                {{ $t('views.label_template.template_fields') }}
              </h2>
              <v-chip-group
                column
                class="mb-6"
              >
                <v-chip
                  v-for="field of fields"
                  :key="field"
                  @click="copyToClipboard(field)"
                >
                  {{ field }}
                </v-chip>
              </v-chip-group>
            </div>

            <div v-if="fonts.length">
              <h2 class="label-template__fields h5 mb-3">
                {{ $t('views.label_template.template_fonts') }}
              </h2>
              <v-chip-group column>
                <v-chip
                  v-for="font of fonts"
                  :key="font"
                  @click="copyToClipboard(font)"
                >
                  {{ font }}
                </v-chip>
              </v-chip-group>
            </div>
          </div>
        </b-col>
      </b-row>
    </main>
  </div>
</template>

<script>
import LabelTemplate from '@/components/labels/LabelTemplate.vue';

export default {
  name: 'LabelTemplates',

  components: {
    LabelTemplate,
  },

  data() {
    return {
      elements: [],
      fields: [],
      fonts: [],
      labelTemplates: [],
    };
  },

  created() {
    this.loadElements();
    this.loadFields();
    this.loadFonts();
    this.loadLabelTemplates();
  },

  methods: {
    async loadElements() {
      try {
        const { data: elements } = await this.$http.get('/labels/elements');
        this.elements = elements;
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },

    async loadLabelTemplates() {
      try {
        const { data: labelTemplates } = await this.$http.get('/labels/types');
        this.labelTemplates = labelTemplates;
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },

    async loadFields() {
      try {
        const { data: fields } = await this.$http.get('/labels/fields');
        this.fields = fields;
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },

    async loadFonts() {
      try {
        const { data: fonts } = await this.$http.get('/labels/fonts');
        this.fonts = fonts;
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },

    copyToClipboard(field) {
      navigator.clipboard.writeText(field);
    },
  },
};
</script>

<style lang="scss">
.label-template {
  padding: 25px 25px 30px 25px;
  background-color: #fff;

  &__select {
    margin-right: 20px;
    padding: 12px 25px;
  }

  &__save {
    padding: 12px 25px;
    color: var(--aurum);

    &:hover {
      color: var(--margaritas);
    }
  }

  &__selected {
    height: 50px;
    margin-top: 20px;

    &-label {
      color: var(--platinum);
    }

    &-filename {
      color: var(--topaz);
    }
  }

  &__fields {
    color: var(--topaz);
  }
}
</style>
